/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import Header from './components/Header'
import MainFields from './components/MainFields'
import Footer from './components/Footer'
import { GetQuotationDetailsById } from '../../hooks/fetch-hooks/quotation-details.js/get-quotation-details-by-id'
import moment from 'moment/moment'
import PrescriptionItems from './prescription-items'
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { UpdateQuotation } from '../../hooks/update-hooks/edit-quotation/quotation-data-update'
import { UpdatePrescriptionItem } from '../../hooks/update-hooks/prescription-item/update-prescription-item'
import { AddPrescriptionItem } from '../../hooks/update-hooks/prescription-item/add-prescription-item'
import { DeletePrescriptionItem } from '../../hooks/update-hooks/prescription-item/delete-prescription-item'
import { UpdatePrescription } from '../../hooks/update-hooks/prescription/update-prescription'
import { debounce, isNil } from 'lodash'
import PaymentsTable from '../../components/PaymentsTable'
import { getOrderPayableTotal } from '../../components/PaymentsTable/helper'
import Loader from '../../components/Loader'
import ItemSubstitutes from '../../components/ItemSubstitutes'
import { useSourcesData } from '../../hooks/fetch-hooks/get-sources'
import { GetPartners } from '../../hooks/fetch-hooks/partners/get-partners'
import { paymentStatus } from '../../components/PaymentsTable/constants'
import utils from '../../utils/utils'
import { GetItemAvailability } from '../../hooks/fetch-hooks/get-item-availability/get-item-availability';
import { CreateIndentTransfer } from '../../hooks/update-hooks/indent-transfer/create-indent-transfer';
import { toast } from 'react-toastify';
import ManualIndentModal from './components/ManualIndentModal';
import IndentTransferCard from '../../components/IndentTransferCard';
import QuotationScreenshot from './components/QuotationScreenshot';
import { TENANT_COMPANY_MAP } from '../../utils/constants';
import { getTenantId } from '../../utils/helpers';
import { useQueryClient } from 'react-query';
import PaymentsItemsTable from '../../components/PaymentsItemsTable/PaymentsItemTable'

export default function EditQuotation() {
    const [searchParams] = useSearchParams();
    const quotationType = searchParams.get('quotationType')
    const { quotationId } = useParams()
    const { data, isFetched, refetch } = GetQuotationDetailsById(quotationId);
    const autoFilledRowIds = useRef(new Set())
    const { data: availabilityResponse, isFetched: isAvailabilityFetched } = GetItemAvailability(quotationId);
    const [orderData, setOrderData] = useState(null)
    const [userData, setuserData] = useState(null);
    const navigate = useNavigate()
    const { getSourcesForChannels } = useSourcesData();
    const { data: partnerData, isLoading: partnersLoading } = GetPartners(null, '');
    const [partners, setPartners] = useState([]);
    const availabilityData = availabilityResponse?.data?.data || null;
    const costEstimation = availabilityResponse?.data?.data?.costEstimation || null;
    const [indentItems, setIndentItems] = useState([]); // Array to store items for indent transfer
    const { mutate: createIndentTransfer, isLoading: isIndentTransferLoading } = CreateIndentTransfer(quotationId);
    const [showManualIndentModal, setShowManualIndentModal] = useState(false);
    const tenantId = getTenantId();
    const isEasydose = process.env.REACT_APP_EASYDOSE_FEATURE_ENABLED === 'true' && tenantId === TENANT_COMPANY_MAP.EAZY;
    const isPillupTenant = tenantId === TENANT_COMPANY_MAP.PILLUP;
    const queryClient = useQueryClient();
    const [notes, setNotes] = useState('');
    const [notesCopied, setNotesCopied] = useState(false);
    const debounceUpdateNotes = useCallback(debounce((value) => UpdateQuotation({ notes: value }, quotationId), 300), [quotationId]);

    // Calculate total payments (SUCCESS and PENDING)
    const calculateTotalPayments = (orderData) => {
        if (!orderData?.payments) return 0;
        return utils.roundOffPaymentAmount(orderData?.payments?.reduce((total, payment) => {
            if (payment.status === paymentStatus.SUCCESS) {
                return total + parseFloat(payment.amount || 0);
            }
            return total;
        }, 0));
    };

    useEffect(() => {
        if (partnerData) {
            setPartners(partnerData.data.data.rows.map((partner) => ({
                id: partner.id,
                name: partner.name
            })));
        }
    }, [partnerData]);

    useEffect(() => {
        let resOrderData = data?.data?.data;
        let prescriptionItems = {}
        const autoFillSaves = []
        resOrderData?.prescription?.prescriptionItems.map((item) => {
            let initialAPiCallPayLoadData = {};
            item.isValidStartdate = true;
            item.isValidEndDate = true;
            item.isValidDuration = true;
            if (!item.startDate) {
                initialAPiCallPayLoadData['startDate'] = moment(resOrderData?.startDate).format('YYYY-MM-DD');
            }
            if (!item.endDate) {
                initialAPiCallPayLoadData['endDate'] = moment(resOrderData?.endDate).format('YYYY-MM-DD');
            }
            if (!item.duration) {
                initialAPiCallPayLoadData['duration'] = resOrderData?.noOfDays
            }
            if (!item.doseSize) {
                initialAPiCallPayLoadData['doseSize'] = 1;
            }
            if (!item.typeOfAdmin) {
                initialAPiCallPayLoadData['typeOfAdmin'] = 'DAYS'
            }
            if (!item.meal) {
                initialAPiCallPayLoadData['meal'] = []
            }
            if (!item.time) {
                initialAPiCallPayLoadData['time'] = []
            }
            const autoFillSave = initialDataUpdate(item.id, initialAPiCallPayLoadData)
            if (autoFillSave) autoFillSaves.push(autoFillSave)
            prescriptionItems[item.id] = item;
        })
        // Refetch once, after the saves land, so the page shows what they wrote.
        if (autoFillSaves.length > 0) Promise.all(autoFillSaves).then(() => refetch())

        if (resOrderData) {
            const payableTotal = getOrderPayableTotal({
                paymentItems: resOrderData?.paymentItems,
                orderTotal: resOrderData?.total,
            });
            const totalPayments = calculateTotalPayments(resOrderData);

            setOrderData({
                prescription: resOrderData.prescription,
                prescriptionItems: prescriptionItems,
                startDate: moment(resOrderData?.startDate).format('YYYY-MM-DD'),
                endDate: moment(resOrderData?.endDate).format('YYYY-MM-DD'),
                noOfDays: resOrderData?.noOfDays,
                drName: resOrderData?.prescription?.drName,
                date: resOrderData?.prescription?.date,
                messages: resOrderData?.messages || [],
                status: resOrderData?.status,
                prescriptionId: parseInt(resOrderData?.prescriptionId),
                notes: resOrderData?.notes,
                userTimings: resOrderData?.mapUserPatient?.Patient?.userDetail?.timings,
                type: resOrderData?.type,
                total: resOrderData?.total,
                payments: resOrderData?.payments,
                mapUserPatient: resOrderData?.mapUserPatient,
                id: resOrderData?.id,
                itemSubstitutes: resOrderData?.itemSubstitutes || [],
                source: resOrderData?.source,
                channel: resOrderData?.channel,
                partner: resOrderData?.partner,
                partnerId: resOrderData?.partnerId,
                orderId: resOrderData?.orderId,
                mappingId: resOrderData?.mapUserPatient?.id,
                payableTotal,
                totalPayments,
                isFullyPaid: totalPayments >= payableTotal,
                isEditable: !(resOrderData?.orderId),
                paymentItems: resOrderData?.paymentItems
            })

            setuserData({
                User: resOrderData?.mapUserPatient.User,
                Patient: resOrderData?.mapUserPatient.Patient,
                prescription: resOrderData?.prescription,
                evitalRx: resOrderData?.inventoryData?.print_url || "",
                address: resOrderData?.address,
                mappingId: resOrderData?.mapUserPatient.id,
            })
        }

    }, [data])

    useEffect(() => {
        setNotes(orderData?.notes || '');
    }, [orderData?.notes]);

    if (!isFetched) {
        return (
            <div className="flex items-center justify-center h-full">
                <Loader size="large" text="Loading quotation details..." />
            </div>
        )
    }

    // Each row gets one attempt per page load. A save that leaves a field empty (say the order has
    // no noOfDays to copy) would otherwise save and refetch forever, and every refetch spends one
    // eVital orders/view call: order 26054 used up the hourly limit that way on 2026-11-05.
    function initialDataUpdate(id, payLoadData) {
        if (Object.keys(payLoadData).length === 0 || autoFilledRowIds.current.has(id)) return null
        autoFilledRowIds.current.add(id)
        return UpdatePrescriptionItem(id, payLoadData).catch((err) => { console.log(err) })
    }
    /**
     * Scroll a prescriptionItem into view
     * @param {*} id 
     */
    const scrollToPrescriptionItemById = (id) => {
        setTimeout(() => {
            const section = document.querySelector(`#prescriptionItem-${id}`);
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 200)
    }

    /**
     * Handles the change of start date or the duration for the order being edited 
     * @param {*} newStartDate 
     * @param {*} newDuration 
     */
    function handleOrderStartDateOrDurationChange(newOrderStartDate = null, newOrderNoOfDays = null, orderData) {
        if (newOrderStartDate === null) newOrderStartDate = moment(orderData.startDate, 'YYYY-MM-DD');
        if (newOrderNoOfDays === null) newOrderNoOfDays = moment(newOrderStartDate).add(orderData.noOfDays - 1, 'days').diff(moment(newOrderStartDate), 'days') + 1;

        let prevOrderStartDate = moment(orderData?.startDate, 'YYYY-MM-DD');
        let prevOrderNoOfDays = parseInt(orderData?.noOfDays);

        let prevPrescriptionItems = JSON.parse(JSON.stringify(orderData?.prescriptionItems));

        for (let id in prevPrescriptionItems) {
            let prescriptionItem = prevPrescriptionItems[id];

            let prevRxItemStartDate = moment(prescriptionItem?.startDate, 'YYYY-MM-DD');
            let prevRxItemDuration = parseInt(prescriptionItem?.duration);

            if (prevRxItemStartDate.isSame(prevOrderStartDate) && prevRxItemDuration === prevOrderNoOfDays) {
                updateItem(id,
                    {
                        startDate: newOrderStartDate.format('YYYY-MM-DD'),
                        duration: parseInt(newOrderNoOfDays)
                    }
                );
            }
        }
        return { startDate: newOrderStartDate.format('YYYY-MM-DD'), noOfDays: newOrderNoOfDays, endDate: moment(newOrderStartDate).add(newOrderNoOfDays - 1, 'days').format('YYYY-MM-DD') };
    }

    /**
     * Get Initial Values for the new prescriptionItem
     * @param {*} itemId 
     * @param {*} itemBatchId 
     * @returns 
     */
    function getInitialValuesForNewPrescriptionItem(itemId, itemBatches) {
        let initialValues = {
            orderId: parseInt(quotationId),
            prescriptionId: parseInt(orderData?.prescriptionId),
            itemId: parseInt(itemId),
            itemBatches: itemBatches || [],
            invoiceItems: [],
            time: [],
            meal: [],
            typeOfAdmin: "DAYS",
            sunday: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            doseSize: 1,
            startDate: orderData?.startDate,
            duration: orderData?.noOfDays,
            endDate: orderData?.endDate
        }

        return initialValues;
    }

    /**
     * 
     * @param  links updates links 
     */
    function updatePrescription(links) {
        setuserData((prevState) => {
            let newPrescription = { ...prevState.prescription };
            newPrescription.links = links
            return { ...prevState, prescription: newPrescription }
        });
    }


    /**
     * Handle today item click if the item is starting today then it will start from tomorrow
     * @param {*} id 
     */
    function handleTodayItem(id) {
        let item = orderData?.prescriptionItems[id];
        if (item.startDate === moment().format('YYYY-MM-DD') && item.duration > 1) {
            updateItem(id, { startDate: moment().add(1, 'days').format('YYYY-MM-DD'), duration: item.duration - 1 })
        }
    }

    /**
         * Updates The OrderData state which have prescription item order startDate endDate noOfDays drName prscriptionDate
         *
         * @param value Value to be changed
         * @param name name of the key to be changed
     */
    function updateOrderData(value, name) {
        let newOrderData = { ...orderData };
        let payLoadData = {};
        payLoadData[name] = value

        if (name === 'noOfDays' || name === 'startDate') {
            let newData = handleOrderStartDateOrDurationChange(name === 'startDate' ? moment(value, 'YYYY-MM-DD') : null, name === 'noOfDays' ? parseInt(value) : null, orderData);
            payLoadData = newData;
            newOrderData = { ...newOrderData, ...newData }
        } else if (name === 'source') {
            // Handle source change logic
            newOrderData[name] = value;
            payLoadData[name] = value;

            // If source is INTERNAL, update order type and clear partnerId
            if (value === "INTERNAL") {
                const currentOrderTypeBase = orderData?.type?.replace('PARTNER_', '').replace('INTERNAL_', '') || '';
                if (currentOrderTypeBase) {
                    const newType = `INTERNAL_${currentOrderTypeBase}`;
                    newOrderData['type'] = newType;
                    payLoadData['type'] = newType;
                }
                newOrderData['partnerId'] = null;
                payLoadData['partnerId'] = null;
            }

            // Clear channel when source changes, but only if the current channel
            // is not valid for the new source
            if (orderData?.channel && value) {
                const newSourceChannels = getSourcesForChannels(value);
                if (!newSourceChannels.includes(orderData.channel)) {
                    newOrderData['channel'] = '';
                    payLoadData['channel'] = '';
                }
            } else if (!value) {
                // Clear channel if no source is selected
                newOrderData['channel'] = '';
                payLoadData['channel'] = '';
                newOrderData['source'] = '';
                payLoadData['source'] = '';
                newOrderData['partnerId'] = null;
                payLoadData['partnerId'] = null;
            }
        } else {
            newOrderData[name] = value;
            payLoadData[name] = value;
        }

        setOrderData(newOrderData);

        if (name == 'drName' || name == 'date') {
            UpdatePrescription(userData.prescription.id, payLoadData)
        } else if (name == 'type') {
            UpdateQuotation(payLoadData, quotationId)
        } else {
            UpdateQuotation(payLoadData, quotationId)
        }
    }

    /**
          * Updates a specific prescriptionItem 
          *
          * @param id Id of the prescriptionItem to be changed
          * @param value Value to be changed
          * @param keyname name of the key to be changed
      */
    function updateItem(id, data) {
        let prevItem = JSON.parse(JSON.stringify(orderData.prescriptionItems[id]));
        let newItem = JSON.parse(JSON.stringify(orderData.prescriptionItems[id]));
        let payLoadData = {};

        for (let keyname in data) {
            let value = data[keyname];

            if (keyname == 'item') {
                payLoadData['itemId'] = parseInt(value?.id)
            } else if (keyname == 'itemBatch') {
                payLoadData['itemBatchId'] = parseInt(value?.id)
            } else if (keyname == 'itemBatches') {
                payLoadData['itemBatches'] = value;
                // Also set the first batch as itemBatchId for backward compatibility
                if (value && value.length > 0) {
                    payLoadData['itemBatchId'] = parseInt(value[0]?.id);
                } else {
                    payLoadData['itemBatchId'] = null;
                }
            } else {
                payLoadData[keyname] = value;
            }

            if (keyname === 'startDate') {
                newItem['startDate'] = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD');
                let endDate = moment(newItem['startDate']).add(newItem['duration'] - 1, 'days').format('YYYY-MM-DD')
                newItem['endDate'] = endDate;
                payLoadData['startDate'] = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD');
                payLoadData['endDate'] = endDate;
            }
            if (keyname === 'duration') {
                let endDate = moment(newItem['startDate']).add(value - 1, 'days').format('YYYY-MM-DD')
                newItem['endDate'] = endDate;
                payLoadData['endDate'] = endDate;
                payLoadData['duration'] = value;
            }
            if (keyname === 'typeOfAdmin' && value === 'DATE') {
                newItem['endDate'] = moment(newItem['startDate']).format('YYYY-MM-DD');
                newItem['duration'] = 1;
                payLoadData['endDate'] = moment(newItem['startDate']).format('YYYY-MM-DD');
                payLoadData['duration'] = 1;
            }
            newItem[keyname] = value;
        }

        setOrderData((prevState) => {
            let prescriptionItems = prevState.prescriptionItems;
            prescriptionItems[id] = newItem;
            return { ...prevState, prescriptionItems: prescriptionItems }
        });
        UpdatePrescriptionItem(id, payLoadData).then((response) => {
            if (!response?.data?.success) {
                setOrderData((prevState) => {
                    let prescriptionItems = prevState.prescriptionItems;
                    prescriptionItems[id] = prevItem;
                    return { ...prevState, prescriptionItems: prescriptionItems }
                });
            }
        });
    }

    /**
        * Add a new prescription Item either duplicate or duplicate with startdate as today
        *
        * @param id Id of the prescriptionItem from which new Item has to be created
        * @param type Either duplicate or today
    */
    function addItem(id, type) {
        let newItem = { ...orderData.prescriptionItems[id] };

        if (type == 'today') {
            newItem.startDate = moment().format();
            newItem.duration = 1;
            newItem.endDate = moment().format();
            handleTodayItem(id);
        }

        // Ensure itemBatches exists in the new item
        if (!newItem.itemBatches && newItem.itemBatchId) {
            // Create itemBatches from the itemBatchId for backward compatibility
            newItem.itemBatches = newItem.itemBatch ? [newItem.itemBatch] :
                (newItem.itemBatchId ? [{ id: newItem.itemBatchId }] : []);
        }

        for (let key in newItem) {
            if (key.includes('Id')) newItem[key] = parseInt(newItem[key]);
            if (isNil(newItem[key])) delete newItem[key];
        }

        delete newItem.id;

        let now = moment().valueOf();

        setOrderData((prevState) => {
            let prescriptionItems = prevState.prescriptionItems;
            prescriptionItems[`${id}:${now}`] = newItem;
            return { ...prevState, prescriptionItems }
        })

        AddPrescriptionItem(newItem).then((response) => {
            if (!response?.data?.success) {
                setOrderData((prevState) => {
                    let prescriptionItems = prevState.prescriptionItems;
                    delete prescriptionItems[`${id}:${now}`];
                    return { ...prevState, prescriptionItems }
                })
            }
            setOrderData((prevState) => {
                let prescriptionItems = prevState.prescriptionItems;
                prescriptionItems[response?.data?.data?.id] = response?.data?.data;
                delete prescriptionItems[`${id}:${now}`];
                return { ...prevState, prescriptionItems }
            })
            scrollToPrescriptionItemById(response?.data?.data?.id);
        });
    }

    /**
         * Add a new fresh prescriptionItem with only name and batch info
         *
         * @param itemId Id of the item is to be added in the prescriptionItem
         * @param itemBatchId Id of the batch of item
    */
    function addNewItem(itemId, itemBatches) {
        let payLoadData = getInitialValuesForNewPrescriptionItem(itemId, itemBatches);
        let now = moment().valueOf();

        setOrderData((prevState) => {
            let prescriptionItems = prevState.prescriptionItems;
            prescriptionItems[`:${now}`] = payLoadData;
            return { ...prevState, prescriptionItems }
        });

        AddPrescriptionItem(payLoadData).then((response) => {
            if (!response?.data?.success) {
                setOrderData((prevState) => {
                    let prescriptionItems = prevState.prescriptionItems;
                    delete prescriptionItems[`:${now}`];
                    return { ...prevState, prescriptionItems }
                })
            }
            setOrderData((prevState) => {
                let prescriptionItems = prevState.prescriptionItems;
                prescriptionItems[response?.data?.data?.id] = response?.data?.data;
                delete prescriptionItems[`:${now}`];
                return { ...prevState, prescriptionItems: prescriptionItems }
            })
            scrollToPrescriptionItemById(response?.data?.data?.id);
        });
    }

    /**
        * Deletes a PrescriptionItem
        *
        * @param id id of the Prescription Item is to be deleted
        * @param itemBatchId Id of the batch of item
    */
    function deleteItem(id) {
        setOrderData((prevState) => {
            let prescriptionItems = prevState.prescriptionItems;
            delete prescriptionItems[id];
            return { ...prevState, prescriptionItems }
        })
        DeletePrescriptionItem(id);
    }

    // Add function to handle adding item to indent list
    const handleAddToIndent = (prescriptionItemId, itemData) => {
        setIndentItems(prev => {
            // Check if item already exists
            const exists = prev.find(item => item.prescriptionItemId === prescriptionItemId);
            if (exists) {
                // Remove if already exists (toggle behavior)
                return prev.filter(item => item.prescriptionItemId !== prescriptionItemId);
            } else {
                // Add new item
                return [...prev, {
                    prescriptionItemId,
                    itemId: itemData.itemId || itemData.item?.id,
                    inventoryId: itemData.inventoryId || itemData.item?.inventoryId,
                    quantity: itemData.quantity || 1, // Adjust based on your data structure
                    ...itemData // Include other necessary fields
                }];
            }
        });
    };

    // Add function to handle indent transfer
    const handleIndentTransfer = async (payload = null) => {
        // If payload is provided (from manual modal), use it
        // Otherwise, use existing indentItems
        const itemsToTransfer = payload?.items || indentItems;

        if (itemsToTransfer.length === 0) {
            toast.warn("Please add items to indent transfer");
            return;
        }

        const indentPayload = payload || {
            items: indentItems.map(item => ({
                inventoryId: item.inventoryId,
                quantity: item.quantity
            }))
        };

        createIndentTransfer(indentPayload, {
            onSuccess: () => {
                setIndentItems([]); // Clear the list after successful transfer
                refetch(); // Refresh quotation data
                queryClient.invalidateQueries(['get-indent-transfer', quotationId]);
            }
        });
    };

    const handleManualIndentCreate = async (payload) => {
        handleIndentTransfer(payload);
    };

    console.log(orderData);

    return (
        <div className='py-3 px-5 flex flex-col gap-3 relative h-full overflow-y-scroll' >
            {(data?.data?.data && orderData && userData !== null) && <Header isFullyPaid={orderData.isFullyPaid} userData={userData} updatePrescription={updatePrescription} refetch={refetch} order={orderData} isEditable={orderData.isEditable} />}
            {orderData !== null && (
                <div className="bg-white px-5 py-4 rounded-lg border border-gray-300 flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label className="text-sm font-medium text-gray-600">Notes</label>
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(notes || '');
                                setNotesCopied(true);
                                setTimeout(() => setNotesCopied(false), 2000);
                            }}
                            className={`text-sm px-5 py-2 rounded-lg font-semibold transition-all duration-200 shadow-sm ${notesCopied ? 'bg-green-500 text-white-50' : 'bg-[#001524] text-white-50 hover:opacity-80'}`}
                        >
                            {notesCopied ? '✓ Copied' : 'Copy Notes'}
                        </button>
                    </div>
                    <textarea
                        rows={5}
                        value={notes}
                        onChange={(e) => {
                            setNotes(e.target.value);
                            debounceUpdateNotes(e.target.value);
                        }}
                        className="rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-800 focus:outline-none focus:border-[#28A48B] resize-none"
                        placeholder="Add notes..."
                        disabled={false}
                    />
                </div>
            )}
            {orderData !== null && isPillupTenant && <PaymentsTable payments={orderData.payments} orderTotal={orderData.total} paymentItems={orderData.paymentItems} isFullyPaid={orderData.isFullyPaid} totalPayments={orderData.totalPayments} refetch={refetch} />}
            {orderData !== null && isPillupTenant && <PaymentsItemsTable paymentItems={orderData.paymentItems} refetch={refetch} quotationId={orderData.id} quotationData={orderData} />}
            {orderData !== null && isPillupTenant && <ItemSubstitutes
                itemSubstitutes={orderData.itemSubstitutes}
                quotationId={quotationId}
                prescriptionItems={orderData.prescriptionItems}
                onRefetch={refetch}
                isEditable={orderData.isEditable}
            />}
            {orderData !== null && isEasydose && (
                <IndentTransferCard quotationId={quotationId} onCreateIndent={() => setShowManualIndentModal(true)} />
            )}
            {orderData !== null && <MainFields orderType={orderData.type} status={orderData.status} partnerId={orderData.partnerId} messages={orderData?.messages} updateOrderData={updateOrderData} startDate={orderData.startDate} noOfDays={orderData.noOfDays} drName={orderData.drName} prescriptionDate={orderData.date} endDate={orderData.endDate} source={orderData.source} channel={orderData.channel} isEditable={orderData.isEditable} partners={partners} partnersLoading={partnersLoading} />}
            {orderData !== null && <PrescriptionItems
                order={orderData}
                addItem={addItem}
                deleteItem={deleteItem}
                updateItem={updateItem}
                Items={orderData.prescriptionItems}
                isEditable={orderData.isEditable}
                availabilityData={availabilityData}
                indentItems={indentItems}
                onAddToIndent={handleAddToIndent}
            />}

            <div className="flex items-center gap-3 mt-4">
                {/* Existing Indent Transfer Section - Only show if items added via buttons */}
                {indentItems.length > 0 && (
                    <div className="flex items-center justify-between flex-1 p-4 bg-blue-50 border-2 border-blue-300 rounded-xl shadow">
                        <div>
                            <div className="text-sm text-blue-800 font-medium">
                                {indentItems.length} item(s) added to indent transfer
                            </div>
                        </div>
                        <button
                            onClick={() => handleIndentTransfer()}
                            disabled={isIndentTransferLoading}
                            className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isIndentTransferLoading ? "Processing..." : "Indent Transfer"}
                        </button>
                    </div>
                )}
            </div>

            <div className="flex items-center justify-between gap-3 mt-4 p-4 bg-[#069079] rounded-xl shadow">
                <div >
                    <div className="text-sm text-gray-100 font-medium">Order Total</div>
                    <div className="text-2xl font-semibold text-white-50">
                        {costEstimation !== null
                            ? costEstimation.toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                                minimumFractionDigits: 2
                            })
                            : orderData?.total?.toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                                minimumFractionDigits: 2
                            }) || '₹0.00'
                        }
                    </div>
                </div>
                {orderData && userData && (
                    orderData?.orderId
                        ? <button
                            type="button"
                            onClick={() => navigate(`/order/edit/${orderData.orderId}`)}
                            className="flex items-center gap-2 px-4 py-2 rounded-xl bg-indigo-600 text-white-50 font-semibold shadow hover:bg-indigo-700"
                          >
                            Go to Order
                          </button>
                        : <QuotationScreenshot
                            quotationId={quotationId}
                            orderData={orderData}
                            userData={userData}
                            costEstimation={costEstimation}
                          />
                )}
            </div>
            {isEasydose && showManualIndentModal && (
                <ManualIndentModal
                    show={showManualIndentModal}
                    onClose={() => setShowManualIndentModal(false)}
                    prescriptionItems={orderData?.prescriptionItems}
                    quotationId={quotationId}
                    onCreateIndent={handleManualIndentCreate}
                    existingIndentItems={indentItems}
                />
            )}
        </div>
    )
}
